import React from "react";
import Footer from "./footer";
import Navbar from "./navbar";

const Termsconditions = () => {
	return (
		<>
			<Navbar />
			{/* <Homecarousel/> */}

			{/* <div
				className="container-fluid bg-primary py-5 mb-5 page-header"
				>
				<div className="container py-5">
					<div className="row justify-content-center">
						<div className="col-lg-10 text-center">
							<h1 className="display-3 text-white animated slideInDown">
								Terms &amp; Conditions
							</h1>
							<nav aria-label="breadcrumb">
								<ol className="breadcrumb justify-content-center">
									<li className="breadcrumb-item">
										<a className="text-white" href="index.php">
											Home
										</a>
									</li>
									<li
										className="breadcrumb-item text-white active"
										aria-current="page">
										Terms &amp; Conditions
									</li>
								</ol>
								<a href="index.php" className="btn btn-success btn-sm">
									Go Back
								</a>
							</nav>
						</div>
					</div>
				</div>
			</div> */}
			<div className="approach-container">
				<div className="approach-inner">
					<h1>Terms and Conditions of Use</h1>

					<div className="approach-content">
						<div className="approach-left">
							<div className="approach-item">
								<p className="approach-description">
									Welcome to the website of{" "}
									<strong>Krishigap Digital Solutions Private Limited</strong>{" "}
									("we", "us", "our"), which operates the{" "}
									<strong>
										Global Academy for Food Safety and Sustainability Standards
									</strong>
									. By accessing or using this website, you (“you”, “your”,
									“user”, or “visitor”) agree to be bound by the following terms
									and conditions, together with our [Privacy Policy] and any
									other applicable policies or notices posted on specific
									sections of the website.
								</p>
							</div>

							<div className="approach-item">
								<h3>1. General Information</h3>
								<p className="approach-description">
									The use of this website is subject to the following terms:
								</p>
								<ul className="approach-list">
									<li>
										The content on this website is for general informational
										purposes only and may be changed or updated without notice.
									</li>
									<li>
										While we strive to ensure the accuracy and reliability of
										the content, we do not guarantee the completeness,
										performance, or suitability of the information and materials
										provided. You acknowledge that such content may contain
										errors or inaccuracies, and we expressly fully exclude
										liability for any such errors permitted by law.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>2. Use at Your Own Risk</h3>
								<ul className="approach-list">
									<li>
										Any use of the materials, content, or services on this
										website is at your own risk. It is your responsibility to
										ensure that any information or services accessed through
										this website meets your specific needs or expectations.
									</li>
									<li>
										We are not liable for any direct, indirect, or consequential
										damage arising from the use of this website or reliance on
										its content.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>3. Intellectual Property</h3>

								<ul className="approach-list">
									<li>
										All design, layout, graphics, and other materials on this
										website are owned by us. Unauthorized reproduction,
										distribution, or use of these materials is strictly
										prohibited and may lead to legal action.
									</li>
									<li>
										All third-party trademarks appearing on the site are
										acknowledged and remain the property of their respective
										owners.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>4. Links to Other Websites</h3>
								<ul className="approach-list">
									<li>
										This website may include links to third-party websites for
										your convenience. These links do not signify endorsement,
										and we are not responsible for the content or practices of
										any linked websites.
									</li>
									<li>
										You may not create a link to this website from another site
										or document without our prior written consent.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>5. Unauthorized Use</h3>

								<ul className="approach-list">
									<li>
										Unauthorized use of this website may give rise to a claim
										for damages and/or constitute a criminal offense under
										applicable laws.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>6. Governing Law</h3>
								<ul className="approach-list">
									<li>
										Your use of this website and any dispute arising therefrom
										shall be governed by the laws of India and subject to the
										exclusive jurisdiction of the courts of Hyderabad ,
										Telangana State, India.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>7. Payment and Transaction Disclaimer</h3>

								<ul className="approach-list">
									<li>
										We, as a merchant, are not responsible for any loss or
										damage arising directly or indirectly due to the decline of
										authorization for any transaction, including instances where
										the cardholder has exceeded the preset limit mutually agreed
										between us and our acquiring bank. Registration fees paid
										for any course through this website are strictly
										non-refundable, regardless of the circumstances.
									</li>
								</ul>
								<p className="approach-description">
									Refer to Our Disclaimer policy
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<Footer />
			</div>
		</>
	);
};

export default Termsconditions;
